const controller = 'OpravaRPKU';

/** Permission codes used by the analysis protocol correction screens and actions. */
export const apcPermissions = {
    updateTechnician: `${controller}/EditOpravaRPTechnik`,
    updateLeaderTechnician: `${controller}/EditOpravaRPVedouciTechnik`,
    updateAdmin: `${controller}/EditOpravaRPAdmin`,
    listTechnician: `${controller}/SeznamOpravaRPTechnik`,
    listLeaderTechnician: `${controller}/SeznamOpravaRPVedouciTechnik`,
    listAdmin: `${controller}/SeznamOpravaRPAdmin`,
};
